import { render, staticRenderFns } from "./TasksList.vue?vue&type=template&id=67fcd3d7&scoped=true"
import script from "./TasksList.vue?vue&type=script&lang=ts"
export * from "./TasksList.vue?vue&type=script&lang=ts"
import style0 from "./TasksList.vue?vue&type=style&index=0&id=67fcd3d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fcd3d7",
  null
  
)

export default component.exports